import Environment from '../constants/Environment';
import { useEnvironment } from '../context/Environment/EnvironmentContext';

export function IsFeatureEnabled(enabled: Environment[]): boolean {
  const { ENVIRONMENT_NAME } = useEnvironment();
  return enabled.includes(ENVIRONMENT_NAME);
}

export default IsFeatureEnabled;
